import { render, staticRenderFns } from "./account-levels.vue?vue&type=template&id=70246fb4&"
import script from "./account-levels.vue?vue&type=script&lang=js&"
export * from "./account-levels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports